<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <div class="animated fadeIn">
      <b-row>
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> Main Settings
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse2" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="6">
                      <TextBox v-model="item.mainChannel" placeholder="@channelName">Bot's Main channel</TextBox>
                    </b-col>
                    <b-col sm="6">
                      <TextBox v-model="item.botURL">Bot URL</TextBox>
                    </b-col>
                    <b-col sm="6">
                      <TextBox v-model="item.inviteCoin" type="number">Referral coins amount</TextBox>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> Daily bonuses
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse1" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="6">
                      <table class="table table-bordered table-sm">
                        <thead class="thead-light">
                        <tr>
                          <th width="50%" scope="col">Days</th>
                          <th width="50%" scope="col">Coins</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(bonus, index) in bonuses" :key="index">
                          <td>
                            <b-form-input v-model="bonus.sorder"
                                          size="sm" type="number">
                            </b-form-input>
                          </td>
                          <td>
                            <b-form-input v-model="bonus.coin"
                                          size="sm" type="number">
                            </b-form-input>
                          </td>
                          <td class="text-center">
                            <b-button variant="danger" size="sm" @click="removeAnswer(bonus)"><i class="icon-close"></i></b-button>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-center">
                            <b-button variant="success" size="sm" @click="addNewRow"><i class="icon-plus"></i> New Item</b-button>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-end">
                    <div class="form-actions">
                      <b-button right type="submit" variant="primary" @click="onSubmit">Save</b-button>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettingsPage',
  data () {
    return {
      item: {},
      bonuses: []
    }
  },
  computed: {
  },
  created () {
    this.$loading.show()
    this.axios.get('settings/item')
      .then(response => {
        this.item = response.data.data
        if (this.item.dailyBonuses) {
          this.bonuses = this.item.dailyBonuses
        }
        this.$loading.hide()
      })
      .catch(error => {
        this.$loading.hide()
        if (error.response && error.response.data.status === 400) {
          this.$toastr.error(error.response.data.message)
        }
      })
  },
  methods: {
    onSubmit () {
      this.$loading.show()
      this.item.dailyBonuses = this.bonuses
      this.axios.put('settings/item', this.item)
        .then((res) => {
          this.$loading.hide()
          if (res.data && res.data.status === 200) {
            this.$toastr.success(res.data.message)
          } else {
            this.$toastr.error(res.data.message)
          }
        })
    },
    removeAnswer (item) {
      const itemIndex = this.bonuses.indexOf(item)
      if (itemIndex !== -1) {
        this.bonuses.splice(itemIndex, 1)
      }
    },
    addNewRow () {
      const order = this.bonuses.length + 1
      this.bonuses.push({
        sorder: order,
        coin: 0
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/settings/SettingsPage.vue